import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { LogService } from './log.service';

@Injectable()
export class ErrorHandlingService {

  constructor (private log: LogService) {}

  handleHttpError(error: any): Observable<any> {
    let errMsg: string;
    let errType: string;
    if (error.status) {
      const err = error.status || JSON.stringify(error);
      errMsg = `${error.status} - ${error.statusText || ''} ${err.message}`;
      errType = err.error_type;
    } else {
      errMsg = error.message ? error.message : error.toString();
      errType = '';
    }
    this.log.error(errMsg);
    return throwError({
      type: errType,
      message: errMsg
    });
  }
}
